import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { TeacherInfo } from '../../../utils/constants'
import {
    TeacherCardImage,
    TeacherCardName,
    TeacherCardTop,
    TeacherCardUniversity,
    TeachersButton,
    TeachersButtonAll,
    TeachersContainer,
    TeachersWrapper,
    LandingSectionContainer,
    TeacherImage,
} from '../style'
function LandingTeachers() {
    const { formatMessage, locale } = useIntl()
    const [activeTeacher, setActiveTeacher] = useState(
        TeacherInfo(formatMessage, locale)[0],
    )

    return (
        <LandingSectionContainer>
            <TeachersContainer>
                <TeachersWrapper>
                    <TeacherCardTop>
                        <TeacherCardName>{activeTeacher.name}</TeacherCardName>
                        <TeacherCardUniversity
                            dangerouslySetInnerHTML={{
                                __html: activeTeacher.info,
                            }}
                        ></TeacherCardUniversity>
                    </TeacherCardTop>

                    <TeacherCardImage>
                        <TeacherImage
                            src={activeTeacher.img}
                            loading="lazy"
                        />
                    </TeacherCardImage>
                    <TeachersButtonAll>
                        {TeacherInfo(formatMessage, locale).map(
                            (item, index) => (
                                <TeachersButton
                                    key={index}
                                    type="button"
                                    className={
                                        activeTeacher.id === item.id
                                            ? 'active'
                                            : ''
                                    }
                                    onClick={() => setActiveTeacher(item)}
                                >
                                    {item.buttonText}
                                </TeachersButton>
                            ),
                        )}
                    </TeachersButtonAll>
                </TeachersWrapper>
            </TeachersContainer>
        </LandingSectionContainer>
    )
}

export default LandingTeachers
